import { render, staticRenderFns } from "./BulkModificationVehicle.vue?vue&type=template&id=0f96d520"
import script from "./BulkModificationVehicle.vue?vue&type=script&lang=js"
export * from "./BulkModificationVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports